'use client';

import { usePathname, useRouter } from 'next/navigation';
import Pagination from 'components/_other/pagination/Pagination';

const PaginationComponent = props => {
  const { handleLinkAttributes = null, ...rest } = props;
  const router = useRouter();
  const pathname = usePathname();
  const defaultPageSize = process.env.NEXT_PUBLIC_BLOG_DEFAULT_PER_PAGE;

  const changePage = (page, pageSize = defaultPageSize) => {
    const href = {
      pathname: pathname,
      query: null,
    };

    const hasQuery = pathname.indexOf('?') !== -1;
    const as = {
      pathname: hasQuery
        ? pathname.substring(0, pathname.indexOf('?'))
        : pathname,
      query: null,
    };

    const queryObject = { page: page > 1 ? page : null };
    if (pageSize !== defaultPageSize) {
      queryObject.perPage = pageSize;
    }

    if (page > 1) {
      href.query = { ...queryObject };
      as.query = { ...queryObject };
    }

    const url = `${href.pathname}?${new URLSearchParams(href.query).toString()}`;

    router.push(url);
  };

  return <Pagination {...rest} changePage={changePage} />;
};

export default PaginationComponent;
